import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Authentication layout component
 * Minimal wrapper for auth pages that handle their own layout
 * Pages like Login and Register use full-width two-column layouts
 */
export function AuthLayout(): React.ReactElement {
  return (
    <div className="min-h-screen bg-phish-bg-0 text-phish-fg-1">
      <Outlet />
    </div>
  );
}

export default AuthLayout;
